import { useEffect, useState } from 'react';
import { getStorytellingAccess } from '../../models/api/storytelling';

/**
 * Whether the user has Storytelling access to at least one project, as the backend says -- it
 * applies the same rule as the Storytelling tab (the subscriber has it on, and the user is an
 * admin or their security group carries a Storytelling permission), across all of the user's
 * projects. False while asking, and on any failure: the card is an extra, so it stays hidden
 * rather than reporting an error.
 */
export default function useStorytellingAccess(): boolean {
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    let current = true;
    getStorytellingAccess()
      .then((access) => current && setHasAccess(access))
      .catch(() => current && setHasAccess(false));
    return () => {
      current = false;
    };
  }, []);

  return hasAccess;
}
